import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'audiences'
const verb = 'post'

export default class OspreyCustomRequestCreate extends BaseAction {
    constructor(dataKey) {
        const id = '5e07b273-5245-4885-af09-0491d8ea729a'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    customRequestCreate(params, contextOrn) {
        this.path = `/${resource}/requests?X-Context-Orn=${contextOrn}`
        this.params = params

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/audiences/custom-request-create.js